import React from "react";

export default function profiles({ Leaderboard }) {
  return <div id="profile">{Item(Leaderboard)}</div>;
}

function Item(data) {
  return (
    <>
      {data.map((value, index) => (
        <div className="flex" key={index}>
          <div className="item">
            <img src={value.profileURL} alt="" />

            <div className="info">
              <h3 className="name text-dark">{value.fullName}</h3>
              <span>@{value.username.replace(/_[0-9]*/g, "")}</span>
            </div>
          </div>
          <div className="item">
            <span>{value.score}</span>
          </div>
        </div>
      ))}
    </>
  );
}
